import React, {useState} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {Box, FormControlLabel, Radio} from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
// Form related
import { Field } from 'formik';
import { RadioGroup } from 'formik-material-ui';
import { DatePicker } from 'formik-material-ui-pickers';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import AddressInput from "components/AddressInput/AddressInput";
import fieldData from '../FormModel/fieldData.js';

import connectionFormStyle from "../../../assets/jss/material-dashboard-react/views/connectionFormStyle";

const state = fieldData.state;
const useStyles = makeStyles(connectionFormStyle);

export default function BusinessDetails(props) {
    let [isCurrentCustomer, setIsCurrentCustomer] = useState(false);
    const classes = useStyles();
    const formField = props.formField;

    const onClick = (event) => {
        if( event.target.name === formField.current_customer.name ) {
            (event.target.value === "yes") ? setIsCurrentCustomer(true) : setIsCurrentCustomer(false);
        }
    };

    const business_type_options = formField.business_type.options.map((item) =>
        <FormControlLabel
            key={item.value}
            value={item.value}
            control={<Radio />}
            label={item.label}
        />
    );

    return (
        <div>
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>1 | Business Details</h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={6}>
                                    <FormControl component="fieldset" className={classes.formControl}>
                                        <FormLabel component="legend">{formField.current_customer.label}</FormLabel>
                                        <Field component={RadioGroup} name={formField.current_customer.name} className={classes.formGroupHorizontal} onClick={onClick}>
                                            <FormControlLabel
                                                value="yes"
                                                control={<Radio />}
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                value="no"
                                                control={<Radio />}
                                                label="No"
                                            />
                                        </Field>
                                    </FormControl>
                                    {isCurrentCustomer ?
                                        <Box>
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.account_no.label}
                                                name={formField.account_no.name}
                                                id={formField.account_no.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                            />
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.current_mobile_no.label}
                                                name={formField.current_mobile_no.name}
                                                id={formField.current_mobile_no.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                            />
                                        </Box>
                                     : null}
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.company_name.label}
                                        name={formField.company_name.name}
                                        id={formField.company_name.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.trading_as.label}
                                        name={formField.trading_as.name}
                                        id={formField.trading_as.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.abn_acn.label}
                                        name={formField.abn_acn.name}
                                        id={formField.abn_acn.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.industry_type.label}
                                        name={formField.industry_type.name}
                                        id={formField.industry_type.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.account_pin.label}
                                        name={formField.account_pin.name}
                                        id={formField.account_pin.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                    <FormControl component="fieldset" className={classes.formControl}>
                                        <FormLabel component="legend">{formField.business_type.label}</FormLabel>
                                        <Field component={RadioGroup} name={formField.business_type.name} className={classes.formGroupHorizontal}>
                                            {business_type_options}
                                        </Field>
                                    </FormControl>
                                    <Field
                                        component={DatePicker}
                                        format="DD/MM/yyyy"
                                        name={formField.trading_start_date.name}
                                        id={formField.trading_start_date.name}
                                        label={formField.trading_start_date.label}
                                        disableFuture={true}
                                        className={classes.itemSpacer + " " + classes.underline}
                                    />
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.director_name.label}
                                        name={formField.director_name.name}
                                        id={formField.director_name.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                    <FormControl component="fieldset" className={classes.formControl + " " + classes.itemSpacer}>
                                        <FormLabel component="legend" style={{marginBottom: "5px"}}>{formField.time_in_industry.label}</FormLabel>
                                        <FormGroup className={classes.formGroupHorizontal}>
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.time_in_industry.fields.industry_years.label}
                                                name={formField.time_in_industry.fields.industry_years.name}
                                                id={formField.time_in_industry.fields.industry_years.name}
                                                formControlProps={{
                                                    fullWidth: false,
                                                    className: classes.groupedInput
                                                }}
                                                inputProps={{
                                                    type: "number"
                                                }}
                                            />
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.time_in_industry.fields.industry_months.label}
                                                name={formField.time_in_industry.fields.industry_months.name}
                                                id={formField.time_in_industry.fields.industry_months.name}
                                                formControlProps={{
                                                    fullWidth: false,
                                                    className: classes.groupedInput
                                                }}
                                                inputProps={{
                                                    type: "number"
                                                }}
                                            />
                                        </FormGroup>
                                    </FormControl>
                                    <FormGroup className={classes.formGroupHorizontal + " " + classes.itemSpacer}>
                                        <Field
                                            component={CustomInput}
                                            labelText={formField.no_of_employees.label}
                                            name={formField.no_of_employees.name}
                                            id={formField.no_of_employees.name}
                                            formControlProps={{
                                                fullWidth: false,
                                                className: classes.groupedInput
                                            }}
                                            inputProps={{
                                                type: "number"
                                            }}
                                        />
                                        <Field
                                            component={CustomInput}
                                            labelText={formField.no_of_locations.label}
                                            name={formField.no_of_locations.name}
                                            id={formField.no_of_locations.name}
                                            formControlProps={{
                                                fullWidth: false,
                                                className: classes.groupedInput
                                            }}
                                            inputProps={{
                                                type: "number"
                                            }}
                                        />
                                    </FormGroup>
                                    <AddressInput formField={formField.current_trading_address} classes={classes} states={state} />
                                    <FormControl component="fieldset" className={classes.formControl + " " + classes.itemSpacer}>
                                        <FormLabel component="legend" style={{marginBottom: "5px"}}>{formField.time_at_current_address.label}</FormLabel>
                                        <FormGroup className={classes.formGroupHorizontal}>
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.time_at_current_address.fields.current_trading_address_years.label}
                                                name={formField.time_at_current_address.fields.current_trading_address_years.name}
                                                id={formField.time_at_current_address.fields.current_trading_address_years.name}
                                                formControlProps={{
                                                    fullWidth: false,
                                                    className: classes.groupedInput
                                                }}
                                                inputProps={{
                                                    type: "number"
                                                }}
                                            />
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.time_at_current_address.fields.current_trading_address_months.label}
                                                name={formField.time_at_current_address.fields.current_trading_address_months.name}
                                                id={formField.time_at_current_address.fields.current_trading_address_months.name}
                                                formControlProps={{
                                                    fullWidth: false,
                                                    className: classes.groupedInput
                                                }}
                                                inputProps={{
                                                    type: "number"
                                                }}
                                            />
                                        </FormGroup>
                                    </FormControl>
                                    <AddressInput formField={formField.previous_trading_address} classes={classes} states={state} />
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter>
                            &nbsp;
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}
